import AppointmentApp from './components/AppointmentApp.vue';
import AppointmentDetailApp from './components/AppointmentDetailApp.vue';
import FullScreenLogin from 'JS/account/app/components/FullScreenLogin.vue';
import Icon from 'JS/components/Icon.vue';
import ResetPassword from './components/ResetPassword.vue';
import SubscriptionApp from './components/SubscriptionApp.vue';
import TrackYourOrder from './components/TrackYourOrder.vue';
import VerifyPassword from 'JS/account/app/components/VerifyPassword.vue';
import Vue from 'vue';
import { IWorkOrderConfirmationResource } from 'JS/types/Automotive';

Vue.component('icon', Icon);

new Vue({
	el: '#appointmentApp',
	render: h => h(AppointmentApp)
});
new Vue({
	el: '#subscriptionApp',
	render: h => h(SubscriptionApp)
});

const detailApp = document.getElementById("appointmentDetailApp");
const trackYourOrder = document.getElementById("trackOrderApp");
const resetPasswordForm = document.getElementById("resetPasswordForm");
const activateAccountForm = document.getElementById("activateAccountForm");

const fullScreenLogin = document.getElementById("fullScreenLogin");
const verifyPasswordPage = document.getElementById("verifyPasswordPage");
const loggedInCustomer = (window as any).loggedInCustomer;

if (trackYourOrder) {
	new Vue({
		el: '#trackOrderApp',
		render: h => h(TrackYourOrder, {
			props: {
				loggedInCustomer
			}
		})
	});
}

if (resetPasswordForm) {
	new Vue({
		el: '#resetPasswordForm',
		render: h => h(ResetPassword)
	});
}

if (activateAccountForm) {
	new Vue({
		el: '#activateAccountForm',
		render: h => h(ResetPassword, {
			props: {
				isActivatePage: true
			}
		})
	});
}

if (detailApp) {
	new Vue({
		el: detailApp,
		render: h => h(AppointmentDetailApp, {
			props: {
				workOrder: (window as any).currentWorkOrder as IWorkOrderConfirmationResource,
			}
		}),
	});
}

if (fullScreenLogin) {
	const destinationUrl = fullScreenLogin.getAttribute('href');
	new Vue({
		el: '#fullScreenLogin',
		render: h => h(FullScreenLogin, {
			props: {
				destinationUrl,
			}
		})
	});
}

if (verifyPasswordPage) {
	const firstName = verifyPasswordPage.getAttribute('first-name');
	const email =  verifyPasswordPage.getAttribute('email');
	let destinationUrl = verifyPasswordPage.getAttribute('destination-url');
	const hasPassword = verifyPasswordPage.getAttribute('has-password');

	if (!destinationUrl) {
		destinationUrl = "/account/";
	}

	new Vue({
		el: '#verifyPasswordPage',
		render: h => h(VerifyPassword, {
			props: {
				firstName,
				email,
				destinationUrl,
				hasPassword
			}
		})
	});
}

